module.exports = __webpack_public_path__ + "img/2f20d31.jpg";